"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetProductBoxPlacement = void 0;
var _analyticsData = require("@ori/analytics-data");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _constants = require("../components/BannerProductListing/constants");
const validatePlacement = (placement)=>{
    if (placement === _analyticsData.Placement.Typeform || placement === _analyticsData.Placement.Revieve) {
        return placement;
    }
    return _analyticsData.Placement.ProductListing;
};
const useGetProductBoxPlacement = ()=>{
    // TODO -- use validate prop when it will be suitable for enums
    const placementParam = (0, _presentationUtils.getTypedQueryParam)({
        name: _constants.ORIGIN_QUERY_KEY,
        fallback: _analyticsData.Placement.ProductListing
    });
    return (0, _react.useMemo)(()=>validatePlacement(placementParam), [
        placementParam
    ]);
};
exports.useGetProductBoxPlacement = useGetProductBoxPlacement;
